import React from 'react'
import Icon from 'svg-inline-react'
import { Avatar } from '@driftt/tide-core-legacy'
import { AvailabilityStatus, AvailabilityStatusIcons } from './constants'
import values from 'ramda/src/values'
import contains from 'ramda/src/contains'

import './style.styl'

export const resolveStatusIcon = user => {
  const isValidAgentStatus = contains(user.availability, values(AvailabilityStatus))
  const agentStatus = isValidAgentStatus ? user.availability : AvailabilityStatus.AWAY
  return AvailabilityStatusIcons.find(icon =>
    icon.availabilityStatus === agentStatus
  ).icon
}

const StatusAvatar = ({ user, size="icon" }) => (
  <div className="agent-status-avatar-wrapper">
    <div className="agent-status-avatar">
      <Avatar size={size} user={user} />
    </div>

    <div className="agent-status-indicator">
      <Icon src={resolveStatusIcon(user)} />
    </div>
  </div>
)

export default StatusAvatar


// WEBPACK FOOTER //
// ./src/scripts/components/shared/AgentStatusAvatar/index.js